import { STORAGE_KEYS, THEMES, Theme, getThemeConfig } from '@cmctechnology/webinvest-constants';
import React, { useEffect } from 'react';
import { createContext, useContext, useState } from 'react';
import { IConfiguration, devConfig, setConfig } from './configuration/configuration';

interface IFrontendContextProps {
  /** Usually set to `${process.env.PUBLIC_URL}/trading` */
  tradingRoutePrefix: string;
  /** Usually set to `${process.env.PUBLIC_URL}` */
  publicUrl: string;
  theme: Theme;
  setTheme: (theme: Theme) => void;
  /** Usually set with getConfig() */
  config: IConfiguration;
  setConfig: (config: IConfiguration) => void;
  containerRef?: React.RefObject<HTMLDivElement>;
}
const FrontendContext = createContext<IFrontendContextProps>({
  tradingRoutePrefix: '',
  publicUrl: '',
  theme: THEMES.CMC,
  setTheme: /* istanbul ignore next */ () => {},
  config: devConfig,
  setConfig: /* istanbul ignore next */ () => {}
});
export const useFrontendContext = () => {
  const context = useContext(FrontendContext);
  const themeConfig = getThemeConfig(context.theme);

  return {
    ...context,
    themeConfig
  };
};

export const FrontendContextProvider: React.FC<React.PropsWithChildren<Omit<IFrontendContextProps, 'setTheme' | 'setConfig'>>> = ({
  tradingRoutePrefix,
  publicUrl,
  theme,
  config,
  children,
  containerRef
}) => {
  const [theTheme, setTheme] = useState(theme);
  const [theConfig, setTheConfig] = useState(config);

  useEffect(() => {
    setConfig(theConfig);
  }, [theConfig]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.Theme, theTheme);
  }, [theTheme]);

  return (
    <FrontendContext.Provider value={{ tradingRoutePrefix, publicUrl, theme: theTheme, setTheme, config: theConfig, setConfig: setTheConfig, containerRef }}>
      {children}
    </FrontendContext.Provider>
  );
};
